import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './SteeringWheel.scss';

const SteeringWheel = (props) => (
    <Icon iconName="SteeringWheel" {...props}>
        <svg width="41px" height="41px" viewBox="0 0 41 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="1440-/-Connectivity-/-Intro-01" transform="translate(-700.000000, -141.000000)" stroke="#000000" strokeWidth="1.5">
                    <g id="Icons-/-Steering-Wheel" transform="translate(701.000000, 142.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M22.1951364,19.7609455 C22.1951364,21.4355818 20.8372273,22.7946727 19.1614091,22.7946727 C17.4855909,22.7946727 16.1276818,21.4355818 16.1276818,19.7609455 C16.1276818,18.0851273 17.4855909,16.7272182 19.1614091,16.7272182 C20.8372273,16.7272182 22.1951364,18.0851273 22.1951364,19.7609455 Z"
                            id="Stroke-1"
                        />
                        <line x1="14.8618364" y1="19.7609455" x2="23.4607455" y2="19.7609455" id="Stroke-3" strokeLinecap="round" />
                        <path
                            // eslint-disable-next-line
                            d="M38.3228182,19.162 C38.3228182,29.744 29.744,38.3228182 19.1608182,38.3228182 C8.57881818,38.3228182 -1.88939773e-13,29.744 -1.88939773e-13,19.162 C-1.88939773e-13,8.57881818 8.57881818,-1.88939773e-13 19.1608182,-1.88939773e-13 C29.744,-1.88939773e-13 38.3228182,8.57881818 38.3228182,19.162 Z"
                            id="Stroke-5"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M9.5472,15.6736273 L12.0124727,14.0947182 C12.9567455,13.4896273 14.0534727,13.1681727 15.1762,13.1681727 L23.1463818,13.1681727 C24.2679273,13.1681727 25.3658364,13.4896273 26.3101091,14.0947182 L28.7753818,15.6736273 L32.5406545,16.8353545 C33.3525636,17.0859 34.1479273,16.3567182 33.9458364,15.5318091 C32.3184727,8.87462727 26.3207455,3.93108182 19.1612909,3.93108182 C12.0018364,3.93108182 6.00410909,8.87462727 4.37674545,15.5318091 C4.17465455,16.3567182 4.97001818,17.0859 5.78192727,16.8353545 L9.5472,15.6736273 Z"
                            id="Stroke-7"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M26.3424909,24.4091545 L24.7954909,25.8722455 C24.1206727,26.5116091 23.2248545,26.8673364 22.2947636,26.8673364 L16.0264,26.8673364 C15.0974909,26.8673364 14.2028545,26.5116091 13.5268545,25.8722455 L11.9798545,24.4091545 L6.84958182,24.4091545 C5.90412727,24.4091545 5.25767273,25.4148818 5.69849091,26.2516091 C8.24649091,31.0887909 13.3129455,34.3919727 19.1605818,34.3919727 C25.0094,34.3919727 30.0746727,31.0887909 32.6238545,26.2516091 C33.0646727,25.4148818 32.4182182,24.4091545 31.4727636,24.4091545 L26.3424909,24.4091545 Z"
                            id="Stroke-9"
                        />
                        <line x1="9.5472" y1="15.6736273" x2="11.9805636" y2="24.4096273" id="Stroke-11" />
                        <line x1="28.7753818" y1="15.6736273" x2="26.3420182" y2="24.4096273" id="Stroke-13" />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default SteeringWheel;
